(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["bw-airrove-drag"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('bw-drag-scroll')) {
  customElements.define('bw-drag-scroll', class extends HTMLElement {
    connectedCallback() {
      if (this.dragController) return;
      this.dragController = new AbortController();
      const options = {signal:this.dragController.signal};
      this.addEventListener('pointerdown', event => this.startDrag(event), options);
      window.addEventListener('pointermove', event => this.moveDrag(event), {...options,passive:false});
      window.addEventListener('pointerup', event => this.endDrag(event), options);
      window.addEventListener('pointercancel', event => this.endDrag(event,true), options);
      window.addEventListener('blur', () => this.endDrag(null,true), options);
      this.addEventListener('lostpointercapture', event => this.endDrag(event,true), options);
      this.addEventListener('dragstart', event => {
        if (this.pointer) event.preventDefault();
      }, options);
      this.addEventListener('click', event => {
        if (this.suppressDragClick && event.detail > 0) {
          event.preventDefault();
          event.stopImmediatePropagation();
          this.suppressDragClick = false;
        }
      }, {...options,capture:true});
      this.dragResize = new ResizeObserver(() => this.toggleAttribute('data-draggable',this.scrollWidth > this.clientWidth + 2));
      this.dragResize.observe(this);
    }
    startDrag(event) {
      clearTimeout(this.clickReset);
      this.suppressDragClick = false;
      if (event.pointerType !== 'mouse' || event.button !== 0 || !event.isPrimary || this.scrollWidth <= this.clientWidth + 2) return;
      if (event.target.closest('input,textarea,select,video,iframe,model-viewer,[data-no-drag]')) return;
      this.scrollTo({left:this.scrollLeft,behavior:'instant'});
      this.pointer = {id:event.pointerId,x:event.clientX,y:event.clientY,left:this.scrollLeft,delta:0,dragged:false,snap:getComputedStyle(this).scrollSnapType !== 'none'};
      this.setAttribute('data-pointer-down','');
    }
    moveDrag(event) {
      const pointer = this.pointer;
      if (!pointer || event.pointerId !== pointer.id) return;
      const delta = event.clientX - pointer.x;
      if (!pointer.dragged) {
        if (Math.abs(delta) < 6) return;
        if (Math.abs(event.clientY-pointer.y) > Math.abs(delta)) {this.endDrag(event,true);return;}
        pointer.dragged = true;
        this.classList.add('is-dragging');
        this.setPointerCapture(pointer.id);
      }
      event.preventDefault();
      pointer.delta = delta;
      this.scrollLeft = pointer.left - delta;
    }
    snapDestination(pointer,cancelled) {
      const max = Math.max(0,this.scrollWidth-this.clientWidth);
      const rect = this.getBoundingClientRect();
      const padding = parseFloat(getComputedStyle(this).scrollPaddingLeft) || 0;
      const stops = [...new Set([0,...[...this.children].map(child => Math.max(0,Math.min(max,child.getBoundingClientRect().left-rect.left+this.scrollLeft-padding))),max])].sort((a,b)=>a-b);
      const nearest = value => stops.reduce((best,stop)=>Math.abs(stop-value)<Math.abs(best-value)?stop:best,stops[0]);
      const start = nearest(pointer.left);
      let target = nearest(this.scrollLeft);
      if (!cancelled && Math.abs(target-start)<1) {
        const index = stops.indexOf(start);
        const next = stops[index+(pointer.delta<0?1:-1)];
        if (next !== undefined && Math.abs(pointer.delta)>Math.min(100,Math.abs(next-start)*.2)) target=next;
      }
      return target;
    }
    endDrag(event,cancelled=false) {
      const pointer = this.pointer;
      if (!pointer || (event && event.pointerId !== pointer.id)) return;
      this.pointer = null;
      const target = pointer.dragged && pointer.snap ? this.snapDestination(pointer,cancelled) : null;
      this.classList.remove('is-dragging');
      this.removeAttribute('data-pointer-down');
      if (this.hasPointerCapture(pointer.id)) this.releasePointerCapture(pointer.id);
      if (pointer.dragged) {
        this.suppressDragClick = true;
        this.clickReset = setTimeout(()=>{this.suppressDragClick=false;},400);
        if (target !== null) this.scrollTo({left:target,behavior:matchMedia('(prefers-reduced-motion: reduce)').matches?'instant':'smooth'});
      }
    }
    disconnectedCallback() {
      this.endDrag(null,true);
      this.dragController?.abort();
      this.dragController = null;
      this.dragResize?.disconnect();
      clearTimeout(this.clickReset);
      this.suppressDragClick = false;
    }
  });
}
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["bw-nks-drag-v1"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('bwk-drag-scroll')) {
  customElements.define('bwk-drag-scroll', class extends HTMLElement {
    connectedCallback() {
      if (this.dragController) return;
      this.dragController = new AbortController();
      const options = {signal:this.dragController.signal};
      this.addEventListener('pointerdown', event => this.startDrag(event), options);
      window.addEventListener('pointermove', event => this.moveDrag(event), {...options,passive:false});
      window.addEventListener('pointerup', event => this.endDrag(event), options);
      window.addEventListener('pointercancel', event => this.endDrag(event,true), options);
      window.addEventListener('blur', () => this.endDrag(null,true), options);
      this.addEventListener('lostpointercapture', event => this.endDrag(event,true), options);
      this.addEventListener('dragstart', event => {
        if (this.pointer) event.preventDefault();
      }, options);
      this.addEventListener('click', event => {
        if (this.suppressDragClick && event.detail > 0) {
          event.preventDefault();
          event.stopImmediatePropagation();
          this.suppressDragClick = false;
        }
      }, {...options,capture:true});
      this.dragResize = new ResizeObserver(() => this.toggleAttribute('data-draggable',this.scrollWidth > this.clientWidth + 2));
      this.dragResize.observe(this);
    }
    startDrag(event) {
      clearTimeout(this.clickReset);
      this.suppressDragClick = false;
      if (event.pointerType !== 'mouse' || event.button !== 0 || !event.isPrimary || this.scrollWidth <= this.clientWidth + 2) return;
      if (event.target.closest('input,textarea,select,video,iframe,model-viewer,[data-no-drag]')) return;
      this.scrollTo({left:this.scrollLeft,behavior:'instant'});
      this.pointer = {id:event.pointerId,x:event.clientX,y:event.clientY,left:this.scrollLeft,delta:0,dragged:false,snap:getComputedStyle(this).scrollSnapType !== 'none'};
      this.setAttribute('data-pointer-down','');
    }
    moveDrag(event) {
      const pointer = this.pointer;
      if (!pointer || event.pointerId !== pointer.id) return;
      const delta = event.clientX - pointer.x;
      if (!pointer.dragged) {
        if (Math.abs(delta) < 6) return;
        if (Math.abs(event.clientY-pointer.y) > Math.abs(delta)) {this.endDrag(event,true);return;}
        pointer.dragged = true;
        this.classList.add('is-dragging');
        this.setPointerCapture(pointer.id);
      }
      event.preventDefault();
      pointer.delta = delta;
      this.scrollLeft = pointer.left - delta;
    }
    snapDestination(pointer,cancelled) {
      const max = Math.max(0,this.scrollWidth-this.clientWidth);
      const rect = this.getBoundingClientRect();
      const padding = parseFloat(getComputedStyle(this).scrollPaddingLeft) || 0;
      const stops = [...new Set([0,...[...this.children].map(child => Math.max(0,Math.min(max,child.getBoundingClientRect().left-rect.left+this.scrollLeft-padding))),max])].sort((a,b)=>a-b);
      const nearest = value => stops.reduce((best,stop)=>Math.abs(stop-value)<Math.abs(best-value)?stop:best,stops[0]);
      const start = nearest(pointer.left);
      let target = nearest(this.scrollLeft);
      if (!cancelled && Math.abs(target-start)<1) {
        const index = stops.indexOf(start);
        const next = stops[index+(pointer.delta<0?1:-1)];
        if (next !== undefined && Math.abs(pointer.delta)>Math.min(100,Math.abs(next-start)*.2)) target=next;
      }
      return target;
    }
    endDrag(event,cancelled=false) {
      const pointer = this.pointer;
      if (!pointer || (event && event.pointerId !== pointer.id)) return;
      this.pointer = null;
      const target = pointer.dragged && pointer.snap ? this.snapDestination(pointer,cancelled) : null;
      this.classList.remove('is-dragging');
      this.removeAttribute('data-pointer-down');
      if (this.hasPointerCapture(pointer.id)) this.releasePointerCapture(pointer.id);
      if (pointer.dragged) {
        this.suppressDragClick = true;
        this.clickReset = setTimeout(()=>{this.suppressDragClick=false;},400);
        if (target !== null) this.scrollTo({left:target,behavior:matchMedia('(prefers-reduced-motion: reduce)').matches?'instant':'smooth'});
      }
    }
    disconnectedCallback() {
      this.endDrag(null,true);
      this.dragController?.abort();
      this.dragController = null;
      this.dragResize?.disconnect();
      clearTimeout(this.clickReset);
      this.suppressDragClick = false;
    }
  });
}
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["bw-waxlet-drag"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('bw-drag-scroll')) {
  customElements.define('bw-drag-scroll', class extends HTMLElement {
    connectedCallback() {
      if (this.dragController) return;
      this.dragController = new AbortController();
      const options = {signal:this.dragController.signal};
      this.addEventListener('pointerdown', event => this.startDrag(event), options);
      window.addEventListener('pointermove', event => this.moveDrag(event), {...options,passive:false});
      window.addEventListener('pointerup', event => this.endDrag(event), options);
      window.addEventListener('pointercancel', event => this.endDrag(event,true), options);
      window.addEventListener('blur', () => this.endDrag(null,true), options);
      this.addEventListener('lostpointercapture', event => this.endDrag(event,true), options);
      this.addEventListener('dragstart', event => {
        if (this.pointer) event.preventDefault();
      }, options);
      this.addEventListener('click', event => {
        if (this.suppressDragClick && event.detail > 0) {
          event.preventDefault();
          event.stopImmediatePropagation();
          this.suppressDragClick = false;
        }
      }, {...options,capture:true});
      this.dragResize = new ResizeObserver(() => this.toggleAttribute('data-draggable',this.scrollWidth > this.clientWidth + 2));
      this.dragResize.observe(this);
    }
    startDrag(event) {
      clearTimeout(this.clickReset);
      this.suppressDragClick = false;
      if (event.pointerType !== 'mouse' || event.button !== 0 || !event.isPrimary || this.scrollWidth <= this.clientWidth + 2) return;
      if (event.target.closest('input,textarea,select,video,iframe,model-viewer,[data-no-drag]')) return;
      this.scrollTo({left:this.scrollLeft,behavior:'instant'});
      this.pointer = {id:event.pointerId,x:event.clientX,y:event.clientY,left:this.scrollLeft,delta:0,dragged:false,snap:getComputedStyle(this).scrollSnapType !== 'none'};
      this.setAttribute('data-pointer-down','');
    }
    moveDrag(event) {
      const pointer = this.pointer;
      if (!pointer || event.pointerId !== pointer.id) return;
      const delta = event.clientX - pointer.x;
      if (!pointer.dragged) {
        if (Math.abs(delta) < 6) return;
        if (Math.abs(event.clientY-pointer.y) > Math.abs(delta)) {this.endDrag(event,true);return;}
        pointer.dragged = true;
        this.classList.add('is-dragging');
        this.setPointerCapture(pointer.id);
      }
      event.preventDefault();
      pointer.delta = delta;
      this.scrollLeft = pointer.left - delta;
    }
    snapDestination(pointer,cancelled) {
      const max = Math.max(0,this.scrollWidth-this.clientWidth);
      const rect = this.getBoundingClientRect();
      const padding = parseFloat(getComputedStyle(this).scrollPaddingLeft) || 0;
      const stops = [...new Set([0,...[...this.children].map(child => Math.max(0,Math.min(max,child.getBoundingClientRect().left-rect.left+this.scrollLeft-padding))),max])].sort((a,b)=>a-b);
      const nearest = value => stops.reduce((best,stop)=>Math.abs(stop-value)<Math.abs(best-value)?stop:best,stops[0]);
      const start = nearest(pointer.left);
      let target = nearest(this.scrollLeft);
      if (!cancelled && Math.abs(target-start)<1) {
        const index = stops.indexOf(start);
        const next = stops[index+(pointer.delta<0?1:-1)];
        if (next !== undefined && Math.abs(pointer.delta)>Math.min(100,Math.abs(next-start)*.2)) target=next;
      }
      return target;
    }
    endDrag(event,cancelled=false) {
      const pointer = this.pointer;
      if (!pointer || (event && event.pointerId !== pointer.id)) return;
      this.pointer = null;
      const target = pointer.dragged && pointer.snap ? this.snapDestination(pointer,cancelled) : null;
      this.classList.remove('is-dragging');
      this.removeAttribute('data-pointer-down');
      if (this.hasPointerCapture(pointer.id)) this.releasePointerCapture(pointer.id);
      if (pointer.dragged) {
        this.suppressDragClick = true;
        this.clickReset = setTimeout(()=>{this.suppressDragClick=false;},400);
        if (target !== null) this.scrollTo({left:target,behavior:matchMedia('(prefers-reduced-motion: reduce)').matches?'instant':'smooth'});
      }
    }
    disconnectedCallback() {
      this.endDrag(null,true);
      this.dragController?.abort();
      this.dragController = null;
      this.dragResize?.disconnect();
      clearTimeout(this.clickReset);
      this.suppressDragClick = false;
    }
  });
}
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["waxlet-result-carousel"] && !Shopify.designMode) return;
  try {
    if(!customElements.get('waxlet-result-carousel'))customElements.define('waxlet-result-carousel',class extends HTMLElement{
 connectedCallback(){
  if(this.resultController)return;
  this.resultController=new AbortController();this.slides=[...this.querySelectorAll('[data-result-slide]')];this.index=0;
  if(!this.slides.length)return;
  this.querySelectorAll('[data-result-step]').forEach(button=>button.addEventListener('click',()=>this.show(this.index+Number(button.dataset.resultStep)),{signal:this.resultController.signal}));
  this.addEventListener('keydown',event=>{
   if(event.target.matches('input[type="range"]'))return;
   if(event.key==='ArrowRight'||event.key==='ArrowLeft'){event.preventDefault();this.show(this.index+(event.key==='ArrowRight'?1:-1));}
  },{signal:this.resultController.signal});
  this.loadObserver=new IntersectionObserver(entries=>{
   if(entries.some(entry=>entry.isIntersecting)){this.slides.forEach((_,i)=>this.ready(i));this.loadObserver.disconnect();}
  },{rootMargin:'700px'});
  this.loadObserver.observe(this);
 }
 ready(index){
  const slide=this.slides[index];
  if(!slide.readyPromise)slide.readyPromise=Promise.all([...slide.querySelectorAll('img')].map(async image=>{
   image.loading='eager';
   try{await image.decode();return image.naturalWidth>0;}catch{return false;}
  })).then(results=>results.every(Boolean));
  return slide.readyPromise;
 }
 async show(index){
  const next=(index+this.slides.length)%this.slides.length,request=(this.request||0)+1;this.request=request;
  this.setAttribute('aria-busy','true');
  const loaded=await this.ready(next);
  if(request!==this.request)return;
  this.removeAttribute('aria-busy');
  if(!loaded){this.slides[next].readyPromise=null;return;}
  this.index=next;
  this.slides.forEach((slide,i)=>{slide.hidden=i!==this.index;});
  this.querySelector('[data-result-current]').textContent=String(this.index+1);
 }
 disconnectedCallback(){this.resultController?.abort();this.loadObserver?.disconnect();this.resultController=null;}
});
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["waxlet-video-compact-r8"] && !Shopify.designMode) return;
  try {
    if(!customElements.get('waxlet-video-compact'))customElements.define('waxlet-video-compact',class extends HTMLElement{
 connectedCallback(){
  if(this.abort)return;this.abort=new AbortController();const options={signal:this.abort.signal};
  this.dialog=this.querySelector('dialog');this.player=this.querySelector('video');const error=this.querySelector('.waxlet-clip-error');
  this.querySelectorAll('[data-clip-src]').forEach(button=>button.addEventListener('click',async()=>{
   this.player.pause();this.player.src=button.dataset.clipSrc;this.player.poster=button.querySelector('img').src;this.player.muted=true;
   this.player.setAttribute('aria-label',button.dataset.clipLabel);error.hidden=true;this.dialog.showModal();
   try{await this.player.play();}catch{error.hidden=false;}
  },options));
  this.querySelector('.waxlet-clip-close').addEventListener('click',()=>this.dialog.close(),options);
  this.dialog.addEventListener('click',event=>{if(event.target!==this.dialog)return;const rect=this.dialog.getBoundingClientRect();if(event.clientX<rect.left||event.clientX>rect.right||event.clientY<rect.top||event.clientY>rect.bottom)this.dialog.close();},options);
  this.dialog.addEventListener('close',()=>{this.player.pause();this.player.removeAttribute('src');this.player.load();},options);
  this.visibility=()=>{if(document.hidden)this.player.pause();};document.addEventListener('visibilitychange',this.visibility,options);
 }
 disconnectedCallback(){this.player?.pause();if(this.dialog?.open)this.dialog.close();this.abort?.abort();this.abort=null;}
});
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["waxlet-video-compact-r9"] && !Shopify.designMode) return;
  try {
    if(!customElements.get('waxlet-video-loop'))customElements.define('waxlet-video-loop',class extends HTMLElement{
 connectedCallback(){
  if(this.abort)return;this.abort=new AbortController();const options={signal:this.abort.signal};
  this.previews=[...this.querySelectorAll('.waxlet-loop-preview')];this.dialog=this.querySelector('dialog');this.player=this.querySelector('.waxlet-full-player');this.toggle=this.querySelector('.waxlet-motion-toggle');this.error=this.querySelector('.waxlet-clip-error');
  this.reduce=matchMedia('(prefers-reduced-motion:reduce)');this.manualPause=this.reduce.matches;this.inView=false;
  this.update=()=>{
   const canPlay=this.inView&&!document.hidden&&!this.dialog.open&&!this.manualPause;
   this.previews.forEach(v=>{v.muted=true;if(canPlay){if(!v.hasAttribute('src'))v.src=v.dataset.previewSrc;v.play().catch(()=>{});}else v.pause();});
   this.toggle.textContent=this.manualPause?'Play previews':'Pause previews';this.toggle.setAttribute('aria-label',this.manualPause?'Play video previews':'Pause video previews');
  };
  this.observer=new IntersectionObserver(entries=>{this.inView=entries[0].isIntersecting;this.update();},{threshold:.12});this.observer.observe(this.querySelector('.waxlet-compact-track'));
  this.toggle.addEventListener('click',()=>{this.manualPause=!this.manualPause;this.update();},options);
  this.querySelectorAll('[data-clip-src]').forEach(button=>button.addEventListener('click',async()=>{
   this.player.pause();this.player.src=button.dataset.clipSrc;this.player.poster=button.querySelector('video').poster;this.player.muted=true;
   this.player.setAttribute('aria-label',button.dataset.clipLabel);this.error.hidden=true;this.dialog.showModal();this.update();
   try{await this.player.play();}catch{this.error.hidden=false;}
  },options));
  this.querySelector('.waxlet-clip-close').addEventListener('click',()=>this.dialog.close(),options);
  this.dialog.addEventListener('click',e=>{if(e.target!==this.dialog)return;const r=this.dialog.getBoundingClientRect();if(e.clientX<r.left||e.clientX>r.right||e.clientY<r.top||e.clientY>r.bottom)this.dialog.close();},options);
  this.dialog.addEventListener('close',()=>{this.player.pause();this.player.removeAttribute('src');this.player.load();this.update();},options);
  document.addEventListener('visibilitychange',()=>{if(document.hidden)this.player.pause();this.update();},options);
  this.reduce.addEventListener('change',()=>{this.manualPause=this.reduce.matches;this.update();},options);this.update();
 }
 disconnectedCallback(){this.previews?.forEach(v=>v.pause());this.player?.pause();this.observer?.disconnect();this.abort?.abort();this.abort=null;}
});
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["waxlet-video-stories-r7"] && !Shopify.designMode) return;
  try {
    if(!customElements.get('waxlet-video-stories'))customElements.define('waxlet-video-stories',class extends HTMLElement{
 connectedCallback(){
  if(this.abort)return;this.abort=new AbortController();const opt={signal:this.abort.signal};
  this.track=this.querySelector('.waxlet-video-track');
  this.videos=[...this.querySelectorAll('video')];
  this.videos.forEach(video=>{
   const card=video.closest('.waxlet-video-card'),button=card.querySelector('.waxlet-video-play'),error=card.querySelector('.waxlet-video-error');
   button.addEventListener('click',async()=>{error.hidden=true;video.muted=true;video.controls=true;try{await video.play();}catch{video.controls=false;button.hidden=false;error.hidden=false;}},opt);
   video.addEventListener('play',()=>{this.videos.forEach(other=>{if(other!==video)other.pause();});button.hidden=true;},opt);
   video.addEventListener('ended',()=>{video.controls=false;button.hidden=false;},opt);
   video.addEventListener('error',()=>{button.hidden=false;error.hidden=false;},opt);
  });
  this.track.addEventListener('keydown',event=>{if(event.target!==this.track)return;if(event.key==='ArrowRight'||event.key==='ArrowLeft'){event.preventDefault();const card=this.querySelector('.waxlet-video-card');this.track.scrollBy({left:(event.key==='ArrowRight'?1:-1)*(card.clientWidth+12),behavior:matchMedia('(prefers-reduced-motion: reduce)').matches?'instant':'smooth'});}},opt);
  this.visibility=()=>{if(document.hidden)this.videos.forEach(v=>v.pause());};document.addEventListener('visibilitychange',this.visibility,opt);
  this.observer=new IntersectionObserver(entries=>entries.forEach(entry=>{if(!entry.isIntersecting)entry.target.pause();}),{threshold:.05});this.videos.forEach(v=>this.observer.observe(v));
 }
 disconnectedCallback(){this.videos?.forEach(v=>v.pause());this.abort?.abort();this.observer?.disconnect();this.abort=null;}
});
  } catch(e) { console.error(e); }
})();

})();
